import React, { useState, useEffect } from "react";
import { getProfile } from "../api/profileApi";
import { ProfileModel } from "../models/ProfileModel";
import styles from "./ProfileForm.module.css";

interface ProfileFormProps {
    profile: ProfileModel;
    onUpdate: (updatedProfile: ProfileModel) => void;
}

const ProfileForm: React.FC<ProfileFormProps> = ({ profile, onUpdate }) => {
    // const [profile, setProfile] = useState<ProfileModel>({} as ProfileModel);
    const [form, setForm] = useState<ProfileModel>(profile);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const fetchProfile = async () => {
            try {
                const data = await getProfile();
                setForm(data);
            } catch (err) {
                setError((err as Error).message);
            } finally {
                setLoading(false);
            }
        };

        fetchProfile();
    }, []);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const name = e.target.name as keyof ProfileModel;
        const value = e.target.value.replace(/px$/g, "");
        setForm({ ...form, [name]: value });
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        onUpdate(form);
    };

    if (loading) return <div className={styles.loading}>Loading...</div>;
    if (error) return <div className={styles.error}>Error: {error}</div>;

    return (
        <form
            onSubmit={handleSubmit}
            className={`${styles.formContainer} rounded-alpha`}
        >
            <div className={styles.formGroup}>
                <label className={styles.label}>
                    User Name:
                    <input
                        className={styles.input}
                        type="text"
                        name="UserName"
                        value={form.UserName}
                        onChange={handleChange}
                    />
                </label>
            </div>
            <div className={styles.formGroup}>
                <label className={styles.label}>
                    Font Size:
                    <input
                        className={styles.input}
                        type="number"
                        name="FontSize"
                        value={(form.FontSize || 12)
                            .toString()
                            .replace("px", "")}
                        onChange={handleChange}
                    />
                </label>
            </div>
            <div className={styles.formGroup}>
                <label className={styles.label}>
                    Text Colour:
                    <input
                        className={styles.colorInput}
                        type="color"
                        name="TextColour"
                        value={form.TextColour}
                        onChange={handleChange}
                    />
                </label>
            </div>
            <div className={styles.formGroup}>
                <label className={styles.label}>
                    Background Colour:
                    <input
                        className={styles.colorInput}
                        name="BackgroundColour"
                        type="color"
                        value={form.BackgroundColour}
                        onChange={handleChange}
                    />
                </label>
            </div>
            <div className={styles.formGroup}>
                <label className={styles.label}>
                    Navigation Background:
                    <input
                        className={styles.colorInput}
                        type="color"
                        name="NavBackgroundColour"
                        value={form.NavBackgroundColour}
                        onChange={handleChange}
                    />
                </label>
            </div>
            <div className={styles.formGroup}>
                <label className={styles.label}>
                    Navigation Text:
                    <input
                        className={styles.colorInput}
                        type="color"
                        name="NavTextColour"
                        value={form.NavTextColour}
                        onChange={handleChange}
                    />
                </label>
            </div>
            <div className={styles.formGroup}>
                <label className={styles.label}>
                    Title Colour:
                    <input
                        className={styles.colorInput}
                        type="color"
                        name="TitleColour"
                        value={form.TitleColour}
                        onChange={handleChange}
                    />
                </label>
            </div>
            <div className={styles.formGroup}>
                <label className={styles.label}>
                    Container Background:
                    <input
                        className={styles.colorInput}
                        type="color"
                        name="ContainerBackgroundColour"
                        value={form.ContainerBackgroundColour}
                        onChange={handleChange}
                    />
                </label>
            </div>
            <div className={styles.formGroup}>
                <label className={styles.label}>
                    Chat Message Background:
                    <input
                        className={styles.colorInput}
                        type="color"
                        name="ChatMessageBackgroundColour"
                        value={form.ChatMessageBackgroundColour}
                        onChange={handleChange}
                    />
                </label>
            </div>
            <div className={styles.formGroup}>
                <label className={styles.label}>
                    Chat Message Text:
                    <input
                        className={styles.colorInput}
                        type="color"
                        name="ChatMessageTextColour"
                        value={form.ChatMessageTextColour}
                        onChange={handleChange}
                    />
                </label>
            </div>
            <button type="submit" className={`${styles.submitButton} btn`}>
                Save
            </button>
        </form>
    );
};

export default ProfileForm;
